import Vue from "vue";
import Router from "vue-router";
import Main from './views/Main.vue'
import GetStarted from './views/GetStarted.vue'
import Save from './views/Save.vue'
import Berechnungsvorlagen from './views/Berechnungsvorlagen.vue'
import ZuUndAbschlaege from './views/ZuUndAbschlaege.vue'
import Wohnflaeche from './views/Wohnflaeche.vue'
import Wohnlage from './views/Wohnlage.vue'
import Baujahr from './views/Baujahr.vue'
import Gebaeudetypen from './views/Gebaeudetypen.vue'
import Haustypen from './views/Haustypen.vue'
import Fussbodenheizung from './views/Fussbodenheizung.vue'
import Sanitaerbereich from './views/Sanitaerbereich.vue'
import Kueche from './views/Kueche.vue'
import Kuechengrundausstattung from './views/Kuechengrundausstattung.vue'
import Elektrogeraete from './views/Elektrogeraete.vue'
import Fussboden from './views/Fussboden.vue'
import ModernisierterBoden from './views/ModernisierterBoden.vue'
import TerrasseBalkon from './views/TerrasseBalkon.vue'
import BesondereAusstattung from './views/BesondereAusstattung.vue'
import ModernisierteFenster from './views/ModernisierteFenster.vue'
import BegruendeteAbweichungen from './views/BegruendeteAbweichungen.vue'
import Betriebskosten from './views/Betriebskosten.vue'
import Berechnungsergebnisse from './views/Berechnungsergebnisse.vue'
import Berechnung from './views/Berechnung.vue'
import Heizung from "@/views/Heizung.vue";

Vue.use(Router);

/*
* Preventing "NavigationDuplicated" errors in console in Vue-router >= 3.1.0
* https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
* */
const routerMethods = ['push', 'replace'];
routerMethods.forEach((method: string) => {
    const originalCall = (Router.prototype as any)[method];
    (Router.prototype as any)[method] = function(location: any, onResolve: any, onReject: any): Promise<any> {
        if (onResolve || onReject) {
            return originalCall.call(this, location, onResolve, onReject);
        }
        return (originalCall.call(this, location) as any).catch((err: any) => err);
    };
});

export default new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Wohnflaeche,
            meta: {
                title: "Wohnfläche"
            }
        },
        {
            path: "/save",
            name: "save",
            component: Save,
            props: true,
            meta: {
                title: "Speichern"
            }
        },
        {
            path: "/berechnungsvorlagen",
            name: "berechnungsvorlagen",
            component: Berechnungsvorlagen,
            meta: {
                title: "Berechnungsvorlagen"
            }
        },
        {
            path: "/zuschlaege",
            name: "zuschlaege",
            component: ZuUndAbschlaege,
            meta: {
                title: "Zu- und Abschläge"
            }
        },
        {
            path: "/wohnflaeche",
            name: "wohnflaeche",
            component: Wohnflaeche,
            meta: {
                title: "Wohnfläche"
            }
        },
        {
            path: "/baujahr",
            name: "baujahr",
            component: Baujahr,
            meta: {
                title: "Baujahr"
            }
        },
        {
            path: "/wohnlage",
            name: "wohnlage",
            component: Wohnlage,
            meta: {
                title: "Wohnlage"
            }
        },
        {
            path: "/gebaeudetyp",
            name: "gebaeudetyp",
            component: Gebaeudetypen,
            meta: {
                title: "Gebäudetyp"
            }
        },
        {
            path: "/haustyp",
            name: "haustyp",
            component: Haustypen,
            meta: {
                title: "Haustyp"
            }
        },
        {
            path: "/heizung",
            name: "heizung",
            component: Heizung,
            meta: {
                title: "Heizung"
            }
        },
        {
            path: "/fussbodenheizung",
            name: "fussbodenheizung",
            component: Fussbodenheizung,
            meta: {
                title: "Fußbodenheizung"
            }
        },
        {
            path: "/sanitaerbereich",
            name: "sanitaerbereich",
            component: Sanitaerbereich,
            meta: {
                title: "Sanitärbereich"
            }
        },
        {
            path: "/kueche",
            name: "kueche",
            component: Kueche,
            meta: {
                title: "Offene Küche"
           }
        },
        {
            path: "/kuechengrundausstattung",
            name: "kuechengrundausstattung",
            component: Kuechengrundausstattung,
            meta: {
                title: "Küchengrundausstattung"
           }
        },
        {
            path: "/elektrogeraete",
            name: "elektrogeraete",
            component: Elektrogeraete,
            meta: {
                title: "Elektrogeräte"
            }
        },
        {
            path: "/fussboden",
            name: "fussboden",
            component: Fussboden,
            meta: {
                title: "Fußboden"
            }
        },
        {
            path: "/modernisierterBoden",
            name: "modernisierterBoden",
            component: ModernisierterBoden,
            meta: {
                title: "Modernisierter Boden"
            }
        },
        {
            path: "/terrasseBalkon",
            name: "terrasseBalkon",
            component: TerrasseBalkon,
            meta: {
                title: "Balkon/Terrasse/Wintergarten"
            }
        },
        {
            path: "/ausstattung",
            name: "ausstattung",
            component: BesondereAusstattung,
            meta: {
                title: "Besondere Ausstattung"
            }
        },
        {
            path: "/modernisierteFenster",
            name: "modernisierteFenster",
            component: ModernisierteFenster,
            meta: {
                title: "Modernisierte Fenster"
            }
        },
        {
            path: "/abweichungen",
            name: "abweichungen",
            component: BegruendeteAbweichungen,
            meta: {
                title: "Begründete Abweichungen"
            }
        },
        {
            path: "/betriebskosten",
            name: "betriebskosten",
            component: Betriebskosten,
            meta: {
                title: "Betriebskosten"
            }
        },
        {
            path: "/berechnungsergebnisse",
            name: "berechnungsergebnisse",
            component: Berechnungsergebnisse,
            meta: {
                title: "Berechnungsergebnisse"
            }
        },
        {
            path: "/berechnung",
            name: "berechnung",
            component: Berechnung,
            meta: {
                title: "Neue Berechnung"
            }
        },
        {path: '*', redirect: '/'} //Fallback 2
    ]
});